import React from 'react'
import { HeroHome } from '../components/HeroHome';

let rutaCarpeta = 'pictures';

// Nombre de la imagen
let nombreImagen = '01.jpg';

// Construir la URL completa de la imagen
let urlImagen = `/${rutaCarpeta}/${nombreImagen}`;


function HomePage({ isMobile, datawelcome, urlImagen }) {
  //console.log(datawelcome[0]);



  return (
    // style={{backgroundColor: 'white'}}
    <div >
      <HeroHome isMobile={isMobile} datawelcome={datawelcome} urlImagen={urlImagen}/> 
      {/* <ServicesHome />
      <AboutUsHome />
      <ContactHome />
      <FaqHome /> */}
    </div>
    
  )
}

export default HomePage